module.exports = __webpack_public_path__ + "static/media/mastercard.79163c80.svg";